import { getEmployeeFullName } from './table.util'

export const joinMultiValue = (value) => {
  if (value == null || value === '') {
    return ''
  }

  if (Array.isArray(value)) {
    return value.filter((item) => item != null && item !== '').join(', ')
  }

  return String(value)
}

const POSTURE_CHECK_EMAIL_FIELDS = ['email', 'username', 'primaryEmail', 'mail', 'userPrincipalName']

export const getPostureCheckRowUserId = (row = {}) => row.userId ?? row.id ?? null

export const normalizePostureCheckUserId = (userId) =>
  userId == null ? '' : String(userId).toLowerCase().replace(/[{}]/g, '').trim()

export const getPostureCheckUserEmail = (row = {}) => {
  const field = POSTURE_CHECK_EMAIL_FIELDS.find((key) => {
    const value = row[key]
    return value != null && value !== ''
  })

  return field ? row[field] : ''
}

export const normalizePostureCheckRoles = (row) => {
  if (row == null) {
    return []
  }

  const roles = row.role ?? row.roles

  if (Array.isArray(roles)) {
    return roles.filter((role) => role != null && role !== '')
  }

  if (roles) {
    return [roles]
  }

  return []
}

export const enrichPostureCheckRow = (row, integrationEmployee) => {
  if (!row) {
    return row
  }

  const email = getPostureCheckUserEmail(row) || integrationEmployee?.email || ''
  const role = normalizePostureCheckRoles(row)
  const enrichedRoles = role.length ? role : normalizePostureCheckRoles(integrationEmployee)

  return {
    ...row,
    email,
    role: enrichedRoles,
  }
}

export const buildIntegrationEmployeesByUserId = (integrationEmployees = []) =>
  integrationEmployees.reduce((acc, employee) => {
    const employeeIdentifier = normalizePostureCheckUserId(employee?.employeeIdentifier)
    if (employeeIdentifier) {
      acc[employeeIdentifier] = employee
    }

    return acc
  }, {})

export const findIntegrationEmployeeForPostureCheckRow = (row, employeesByUserId = {}) => {
  const rowUserId = normalizePostureCheckUserId(getPostureCheckRowUserId(row))
  if (rowUserId && employeesByUserId[rowUserId]) {
    return employeesByUserId[rowUserId]
  }

  return null
}

export const enrichPostureCheckRows = (rows = [], integrationEmployees = []) => {
  const employeesByUserId = buildIntegrationEmployeesByUserId(integrationEmployees)

  return rows.map((row) =>
    enrichPostureCheckRow(row, findIntegrationEmployeeForPostureCheckRow(row, employeesByUserId)),
  )
}

export { getEmployeeFullName }
